import React from 'react';
import {
  Box,
  Alert,
  ProChip,
  Button,
  IconArrowForward,
  Typography,
} from '@capitalise/ui-design-system';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';

export interface DirectorConsentBannerProps {
  onClick: () => void;
}

const DirectorConsentBanner = ({ onClick }: DirectorConsentBannerProps) => {
  const { isMobile } = useMediaQuery();
  return (
    <Alert
      wrapperProps={isMobile ? { flexDirection: 'column', alignItems: 'start' } : null}
      actionLabel={
        <Button
          onClick={() => null}
          rightIcon={<IconArrowForward />}
          variant="text"
          baseColor="warning"
        >
          Provide consent
        </Button>
      }
      icon={() => <ProChip variant="filled" color="warning" />}
      onActionClick={onClick}
      closable={false}
      type="warning"
    >
      <Typography size="body-16" color="grey-900">
        <Box typography="heading-16" color="grey-900" as="span" display="inline-block">
          Identify as a director.&nbsp;
        </Box>
        Consent from a director is required to access your full Experian credit profile.
      </Typography>
    </Alert>
  );
};

export default DirectorConsentBanner;
